import Immutable from 'seamless-immutable';
import { GENERAL_STATUSES } from '../../shared/constants/general.status.constants';
export var APPLY_DISCOUNT_OPTION_ID = 'APPLY_DISCOUNT_OPTION_ID';
export var CHANGE_SUBSCRIPTION_OFFER_OPTION_ID = 'CHANGE_SUBSCRIPTION_OFFER_OPTION_ID';
export var MODIFY_RENEWAL_OPTION_ID = 'MODIFY_RENEWAL_OPTION_ID';
export var MODIFY_SUBSCRIPTION = 'MODIFY_SUBSCRIPTION';
export var MODIFY_SUBSCRIPTION_OFFER_OPTION_ID = 'MODIFY_SUBSCRIPTION_OFFER_OPTION_ID';
export var REMOVE_SUBSCRIPTION_EXTENSION_OPTION_ID = 'REMOVE_SUBSCRIPTION_EXTENSION_OPTION_ID';
export var REMOVE_SUBSCRIPTION_OPTION_ID = 'REMOVE_SUBSCRIPTION_OPTION_ID';
export var REMOVE_SUBSCRIPTION_OFFER_OPTION_ID = 'REMOVE_SUBSCRIPTION_OFFER_OPTION_ID';
export var REACTIVATE_SUBSCRIPTION_OPTION_ID = 'REACTIVATE_SUBSCRIPTION_OPTION_ID';
export var REPLACE_SUBSCRIPTION_OPTION_ID = 'REPLACE_SUBSCRIPTION_OPTION_ID';
export var RESTORE_SUBSCRIPTION_OPTION_ID = 'RESTORE_SUBSCRIPTION_OPTION_ID';
export var VIEW_PAYMENT_HISTORY_OPTION_ID = 'VIEW_PAYMENT_HISTORY_OPTION_ID';
export var SUBSCRIPTION_STATUSES = Object.assign({
  PENDING_ACTIVE: 5,
  PENDING_REMOVED: 6
}, GENERAL_STATUSES);
export var PAYMENT_METHOD_STATUSES = GENERAL_STATUSES;
export var SUBSCRIPTION_TABS = {
  INFO: 'info',
  DISCOUNT: 'discount',
  PRICING_HISTORY: 'pricing_history',
  ADDITIONAL_INFO: 'additional_info'
};
export var SUBSCRIPTION_TYPE = {
  MANUAL: 1,
  AUTOMATIC: 2
};
export var EXTENSION_STATUS_INDICATOR_STATUS = {
  ACTIVE: 1,
  UPCOMING: 2
};
export var DISCOUNT_SOURCE = Immutable({
  PRICING_PLAN: 1,
  COUPON: 2,
  GLOBAL: 3,
  DISCRETIONARY: 4,
  PRODUCT_PURCHASE: 5,
  INSTANT: 6,
  QUANTITY: 7,
  EPISODIC_PURCHASE: 8
});